import { PaymentDetailedComponent } from './components/my-orders/payment-detailed/payment-detailed.component';
import { DownloadOrdersComponent } from './components/download-orders/download-orders.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { ReferralCodeComponent } from './components/referral-code/referral-code.component';
import { AddressesComponent } from './components/addresses/addresses.component';
import { MyOrdersComponent } from './components/my-orders/my-orders.component';
import { DownloadOrdersResolver } from './resolvers/download-orders.resolver';
import { SettingComponent } from './components/setting/setting.component';
import { UserPaymentsResolver } from './resolvers/user-payments.resolver';
import { ReferralCodeResolver } from './resolvers/referral-code.resolver';
import { PaymentResolver } from '../payment/resolvers/payment.resolver';
import { UserReportResolver } from './resolvers/user-report.resolver';
import { RouterModule, Routes } from '@angular/router';
import { UserComponent } from './user.component';
import { UserIsLoggedInGuard } from './guards/user.guard';

const routes: Routes = [
  {
    path: '',
    component: UserComponent,

    children: [
      {
        path: '',
        component: UserDashboardComponent,
        data: { animation: 'openClosePage' },
      },

      {
        path: 'referral',
        component: ReferralCodeComponent,

        // resolve: {
        //   referral: ReferralCodeResolver,
        // },
      },

      {
        path: 'my-orders',
        component: MyOrdersComponent,
        resolve: {
          payments: UserPaymentsResolver,
        },
        canActivate: [UserIsLoggedInGuard],

        data: { animation: 'openClosePage' },
      },

      {
        path: 'my-orders/detailed/:hash',
        component: PaymentDetailedComponent,
        resolve: {
          payment: PaymentResolver,
        },
      },

      {
        path: 'download-orders',
        component: DownloadOrdersComponent,

        resolve: {
          orders: DownloadOrdersResolver,
        },
      },

      {
        path: 'setting',
        component: SettingComponent,
        data: { animation: 'openClosePage' },
      },

      {
        path: 'wallet',
        loadChildren: () =>
          import('./_modules/wallet/wallet.module').then(
            (result) => result.WalletModule
          ),
        data: { animation: 'openClosePage' },
      },

      {
        path: 'addresses',
        component: AddressesComponent,
        data: { animation: 'openClosePage' },
      },
    ],
    resolve: {
      user: UserReportResolver,
    },
  },
];

export const userRouter = RouterModule.forChild(routes);
